import React from 'react'
import CropModal from './CropModal'
import { Field, reduxForm } from 'redux-form'
import '../../css/icons.min.css'

class StepThree extends React.Component {
	
	constructor(props) {
		super(props)
		this.state = {
			imgURI: "",
			showUpload: true,
			disableSubmit: false,
			submitting: false
		}
	}
	
	setDisable() {
		this.setState({
			disableSubmit: true
		})
	}
	
	removeDisable() {
		this.setState({
			disableSubmit: false
		})
	}
	
	getBase64 = (file) => {
		let reader = new FileReader()
		reader.readAsDataURL(file)
		reader.onload = function () {
			this.setState({
				imgURI: reader.result,
				showUpload: false
			})
		}.bind(this)
		reader.onerror = function (error) {
			console.log('Error: ', error)
		}
	}

	fileUpload = () => {
		let fileModule = document.getElementById('fileInput')
		let toUpload = fileModule.files[0]
		this.getBase64(toUpload)
	}
	
	refreshUpload = () => {
		document.getElementById("uploadedImageWrapper").classList.remove('active')
		document.getElementById("uploadedImage").removeAttribute('src')
		this.setState({
			imgURI: "",
			showUpload: true,
			disableSubmit: false
		})
	}
	
	verifyInputs() {
		this.setState({
			disableSubmit: true,
			submitting: true
		})
		this.props.handleFormSubmit()
	}
	
	handleKeyPress(e) {
		if(e.key == 'Enter'){
			this.verifyInputs()
		}
	}
	
	render() {
		return (
			<div>
				<label className={ this.state.disableSubmit ? "d-none" : "" }>Headline<small className="optional">(Optional)</small></label>
				<Field name="headline" className={ this.state.disableSubmit ? "d-none" : "form-control" } component="input" type="text" onKeyPress={ this.handleKeyPress.bind(this) } />
				<label>Profile Picture<small className="optional">(Optional)</small></label>
				<div className="file-upload-wrapper lg">
					<div className="file-upload-image" id="uploadedImageWrapper">
						<img id="uploadedImage"/>
					</div>
					<CropModal imgURI={ this.state.imgURI } setDisable={ this.setDisable.bind(this) } removeDisable={ this.removeDisable.bind(this) } />
					<div>
						{this.state.showUpload ? (
							<div className="file-upload btn btn-upload">
								<span><span className="icon icon-image"></span> Upload Image<br/><small>At least 450x450<br/>1:1 Aspect Ratio</small></span>
								<input id="fileInput" className="form-control-file upload" type="file" accept="image/x-png,image/jpeg" onChange={ this.fileUpload.bind(this) }/>
							</div>
						):[(this.state.submitting ?(
							<button key="1" type="button" className="btn-void" onClick={ this.refreshUpload.bind(this) } disabled>Select a New Image</button>
						):(
							<button key="2" type="button" className="btn-void" onClick={ this.refreshUpload.bind(this) }>Select a New Image</button>
						))]}
					</div>
				</div>
				{!this.state.disableSubmit ? (
					<div>
						<button type="button" className="btn btn-login" onClick={ this.verifyInputs.bind(this) }>Sign up</button>
						<a className="retrace" onClick={ this.props.prevStep }>Go back</a>
					</div>
				):(!this.state.submitting ? (
					<button type="button" className="btn btn-login" onClick={ this.verifyInputs.bind(this) } disabled>Sign up</button>
					): (
					<button type="button" className="btn btn-login" onClick={ this.verifyInputs.bind(this) } disabled>Signing Up <i className="fa fa-spinner fa-spin"></i></button>
				))}
			</div>
		)
	}
}

export default StepThree


// WEBPACK FOOTER //
// ./src/components/Modals/StepThree.js